// extracted by mini-css-extract-plugin
export default {"place-form":"NewPlace_place-form__VvbCb"};